import { render } from "./topnav.vue?vue&type=template&id=31de8eb2"
import script from "./topnav.vue?vue&type=script&lang=js"
export * from "./topnav.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__